import React from 'react';
import { Platform, Text } from 'react-native';
import { Link, type Href } from 'expo-router';
import { useFontLoading } from '../../lib/FontContext';
import { interRegular, interSemiBold } from '../../lib/fonts';
import { boundarySafeHref } from '../../lib/i18n/publicWeb';
import { s } from './briefStyles';

export { s } from './briefStyles';

export function Body({ children }: { children: React.ReactNode }) {
    const { fontsLoaded } = useFontLoading();
    return <Text style={[s.body, fontsLoaded && interRegular]}>{children}</Text>;
}

export function Heading({ children }: { children: React.ReactNode }) {
    const { fontsLoaded } = useFontLoading();
    return <Text accessibilityRole="header" {...(Platform.OS === 'web' ? { 'aria-level': 2 } : {})}
        style={[s.h2, fontsLoaded && interSemiBold]}>{children}</Text>;
}

export function BriefLink({ href, children }: { href: string; children: React.ReactNode }) {
    return <Link href={boundarySafeHref(href as Href)} style={s.link}>{children}</Link>;
}
